import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Skeleton } from 'primereact/skeleton';
import { InputText } from 'primereact/inputtext';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import TableComponent from '../AllSubmissions/TableComponent';
import { MultiSelect } from 'primereact/multiselect';
import Modal from 'react-bootstrap/Modal';
import { Breadcrumb, Dropdown, DropdownButton, Spinner, Tooltip, OverlayTrigger} from 'react-bootstrap';
import * as constants from 'Constants';
import fileDownload from 'js-file-download';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import { useDebounce } from 'use-debounce';
// import Card from 'react-bootstrap/Card';
import { useDispatch, useSelector } from 'react-redux';
import { loadCoursesListRequest } from 'Screens_old/PublicCourses/Common/Actions/Actions';
import httpService from 'services/httpService.js';
import { FaDownload } from 'react-icons/fa';
import { FaUsers, FaClipboardList, FaCode } from 'react-icons/fa';
import { IoLogoElectron } from "react-icons/io5";
import { AiOutlineAppstore } from 'react-icons/ai';
import { loadCoursesListRequest as instructor_loadCoursesListRequest } from 'Store/MyDashboard/Instructor/Actions';
import { toast } from "react-toastify";
import log from "loglevel";

function Submissions({ routeProps }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const url = location.pathname;
    const urlArray = url.split('/');
    const courseId = urlArray[3];
    const labID = urlArray[6];

    const [submissionsSummary, setSubmissionsSummary] = useState([{}]);
    const [submissions, setSubmissions] = useState([undefined]);
    const [listOfAllSubmissions, setListOfAllSubmissions] = useState([]);
    const [labTitle, setLabTitle] = useState(location.labTitle);
    const [deadline, setDeadline] = useState(null);
    const [activityTitle, setActivityTitle] = useState('');
    const [loaded, setLoaded] = useState(false);
    const [expandedRows, setExpandedRows] = useState(null);

    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [lazyLoading, setLazyLoading] = useState(false);
    const [sortField, setSortField] = useState(
        sessionStorage.getItem('labSortField') || ''
    );
    const [sortOrder, setSortOrder] = useState(
        sessionStorage.getItem('labSortOrder') || ''
    );
    const [querySortOrder, setQuerySortOrder] = useState(
        sessionStorage.getItem('labQuerySortOrder') || ''
    );
    const [searchQuery, setSearchQuery] = useState(''); //Used for filtering
    const [debouncedSearchQuery] = useDebounce(searchQuery, 500); //Used for debouncing the search query
    const [isNewData, setIsNewData] = useState(false);

    const rows = 100;

    const [selectedSubmissions, setSelectedSubmissions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [errorDetails, setErrorDetails] = useState('');

    //Used for selecting the columns which are to be displayed in the submissions page
    const [activities, setActivities] = useState([]);
    const [visibleLabSubmisssionsColumns, setvisibleLabSubmisssionsColumns] =
        useState(
            JSON.parse(
                sessionStorage.getItem('visibleLabSubmisssionsColumns')
            ) || []
        );
    const [coursename, setCoursename] = useState('');
    let instructorCourses = useSelector((state) => state.instructorCoursesMap);
    let courses = useSelector((state) => state.publicCoursesMap);
    const hiddenColumns = [
        { name: 'Email' },
        { name: 'Name' },
        { name: 'Roll no' },
        { name: 'Uploaded on' },
        { name: 'Activities Submitted' },
        { name: 'Activities' },
    ];

    useEffect(() => {
        var tempCourse;
        if (courses?.length > 0) {
            tempCourse = courses.find((item) => item.id === Number(courseId));
            setCoursename(tempCourse?.title);
        }
        if (!tempCourse) {
            if (instructorCourses && instructorCourses.length > 0) {
                tempCourse = instructorCourses.find(
                    (item) => item.id === Number(courseId)
                );
                setCoursename(tempCourse?.title);
            }
        }
    }, [courses,instructorCourses]);

    useEffect(() => {
        dispatch(loadCoursesListRequest());
        dispatch(instructor_loadCoursesListRequest());
    }, [dispatch]);

    useEffect(() => {
        const fetchdata = async () => {
            sessionStorage.setItem('labSortField', sortField);
            sessionStorage.setItem('labSortOrder', sortOrder);
            sessionStorage.setItem('labQuerySortOrder', querySortOrder);
            try {
                var url =
                    constants.base_url +
                    '/evalpro/labsubmissions/' +
                    labID +
                    '?page=' +
                    1 +
                    '&page_size=' +
                    100 +
                    '&search_query=' +
                    debouncedSearchQuery +
                    '&sort=' +
                    querySortOrder +
                    sortField;
                setLazyLoading(true);
                const response = await httpService.get(url);
                setActivities(response.data.submissions.activities);
                setSubmissionsSummary(response.data.submissions);
                setListOfAllSubmissions(
                    response.data.submissions.submission_id_list
                );
                const length = response.data.submissions.submissions.count;
                setSubmissions(Array.from({ length }));
                setIsNewData(true);
                setLoaded(true);
            } catch (error) {
                toast.error(error.response.data.error_msg, {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
            // checkIntelligentGradingStatus();
        };
        fetchdata();
    }, [sortOrder, sortField, debouncedSearchQuery]);

    const downloadAllSubmissions = async (e) => {
        const FileDownload = require('js-file-download');

        if(selectedSubmissions.length==0){
            displayGlobalMessage('Select atleast one student!!','error');
            return;
        }
        
        try {
            var url =
                constants.base_url +
                '/evalpro/labsubmissions/download_zip/' +
                labID;
            let requestData = {};
            if(isSelectAllChecked){
                url+= "?select_all=true";
            }
            else{
                const allEmpty = selectedSubmissions.every(submission => 
                    Object.keys(submission.activities).length === 0
                );
                if(allEmpty){
                    displayGlobalMessage("All selected student haven't submitted any activity!!",'error');
                    return;
                }
                const student_ids = selectedSubmissions.map(submission=>submission.student);
                requestData = { student_ids };
            }
            const response = await httpService.instance({
                url,
                method: 'POST',
                data: requestData,
                responseType: 'blob', // Important
            });
            FileDownload(response.data, 'Submissions_' + labID + '.zip');

            displayGlobalMessage(
                'Submissions Exported Successfully!',
                'success'
            );
        } catch (error) {
            log.error(error);
            displayGlobalMessage('Some Error occured in Backend!','error');
        }
    };

    // This useEffect is used to get the title of the lab
    useEffect(() => {
        const fetchlab = async () => {
            try {
                if (!courseId) {
                    return;
                }
                if (labID) {
                    var url =
                        constants.base_url +
                        '/lab/all/' +
                        labID +
                        `?courseId=${courseId}`;
                    const response = await httpService.get(url);
                    setLabTitle(response.data.lab.title);
                    setDeadline(response.data.lab.available_till);
                }
            } catch (error) {
                log.error(error);
            }
        };
        fetchlab();
    }, [labID, courseId]);

    useEffect(() => {
        sessionStorage.setItem(
            'visibleLabSubmisssionsColumns',
            JSON.stringify(visibleLabSubmisssionsColumns)
        );
    }, [visibleLabSubmisssionsColumns]);

    const downloadAllSubmissionsCSV = async (e) => {
        try {
            var url =
                constants.base_url +
                '/evalpro/labsubmissions/download_csv/' +
                labID;
            const response = await httpService.get(url, {
                responseType: 'blob',
            });
            fileDownload(response.data, 'submissions.csv');
            displayGlobalMessage(response.data.status, 'success');
        } catch (error) {
            log.log(error);
            displayGlobalMessage('Error In downloading results', 'error');
        }
    };

    // This function is used to handle the search query
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // This function is used to handle the select all checkbox

    // This function is used to show the header component of the submissions page
    const showHeaderComponent = () => {
        return (
            <div>
                {/* <div className="courseHeader" style={{lineHeight:"22px",height:"30px",}}>
          <div className="d-flex flex-row container justify-content-left" style={{ minWidth: "100%",}}>
              {coursename && <div className="courseHeaderTitle" style={{fontSize:"28px",}}>{coursename} : {labTitle}</div>}
          </div>
        </div> */}
                <div
                    className="row p-1 m-2"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                    }}
                >
                    <div className="col-md-4 col-lg-2 col-xl-2">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3 mb-3">
                                    <FaUsers size={24} />
                                </div>
                                <h3 className="fs-2 fw-bold mb-0">
                                    {submissionsSummary['total_students']}
                                </h3>
                                <p className="mb-0 mt-2">Total Students</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2 col-xl-2">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3 mb-3">
                                    <FaClipboardList size={24} />
                                </div>
                                <h3 className="fs-2 fw-bold mb-0">
                                    {submissionsSummary['total_submissions']}
                                </h3>
                                <p className="mb-0 mt-2">Active Students</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-2 col-xl-2">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3 mb-3">
                                    <FaCode size={24} />
                                </div>
                                <h3 className="fs-2 fw-bold mb-0">
                                    {
                                        submissionsSummary[
                                            'programming_activities'
                                        ]
                                    }
                                </h3>
                                <p className="mb-0 mt-2">
                                    Programming Activities
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-2 col-xl-2">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3 mb-3">
                                    <IoLogoElectron size={24} />
                                </div>
                                <h3 className="fs-2 fw-bold mb-0">
                                    {submissionsSummary['virtual_activities']}
                                </h3>
                                <p className="mb-0 mt-2">Virtual Activities</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-2 col-xl-2">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-4">
                                <div className="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3 mb-3">
                                    <AiOutlineAppstore size={24} />
                                </div>
                                <h3 className="fs-2 fw-bold mb-0">
                                    {submissionsSummary['other_labs']}
                                </h3>
                                <p className="mb-0 mt-2">Other Activities</p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="col-md-4 col-lg-2 col-xl-2"
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flext-start',
                        }}
                    >
                            <DropdownButton
                                id="allsubmission"
                                title={
                                    <FaDownload color="#4b5563" size="2.5rem" />
                                }
                                className="btn-lg"
                                variant="link"
                                align={{ lg: 'end' }}
                                size="lg"
                            >
                                <Dropdown.Item
                                    onClick={(e) => {
                                        downloadAllSubmissions(e);
                                    }}
                                >
                                    Download Selected Submissions
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={(e) => {
                                        downloadAllSubmissionsCSV(e);
                                    }}
                                >
                                    Download as CSV
                                </Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </div>
                </div>
        );
    };

    const loadingTemplate = (options) => {
        return (
            <div
                className="flex align-items-center"
                style={{ height: '17px', flexGrow: '1', overflow: 'hidden' }}
            >
                <Skeleton width={'60%'} height="1rem" />
            </div>
        );
    };

    const textEditor = (options) => {
        if (options.rowData.submission_status !== 'Not Uploaded')
            return (
                <div className="d-flex align-items-center">
                    <InputText
                        type="text"
                        value={options.value}
                        onChange={(e) => options.editorCallback(e.target.value)}
                    />
                </div>
            );
        else return <div></div>;
    };

    const timeTemplate = (rowData) => {
        if (!rowData) return;
        const { latestupload } = rowData;
        if (latestupload) {
            const date = new Date(latestupload);
            const formattedDate = getFormattedTimeStamp(latestupload);
            const thresholdDate = new Date(deadline);
            const cellStyle =
                date < thresholdDate ? { color: '#4b5563' } : { color: 'red' };

            return <span style={cellStyle}>{formattedDate}</span>;
            // return formattedDate;
        } else {
            const cellStyle = { color: '#4b5563' };
            return <span style={cellStyle}>Not Submitted</span>;
        }
    };

    const getFormattedTimeStamp = (timestamp) =>{
        const date = new Date(timestamp);
        // Formatting options
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };

        // Format the date using Intl.DateTimeFormat
        const formattedDate = new Intl.DateTimeFormat(
            'en-GB',
            options
        ).format(date);
        return formattedDate;
    }

    const tableHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <MultiSelect
                    value={visibleLabSubmisssionsColumns}
                    onChange={(e) => setvisibleLabSubmisssionsColumns(e.value)}
                    options={hiddenColumns}
                    optionLabel="name"
                    filter
                    display="chip"
                    placeholder="Select Columns"
                    maxSelectedLabels={3}
                    style={{ width: '350px' }}
                />

                <InputText
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search"
                />
            </div>
        );
    };

    const handleSort = (event) => {
        setSortField(event.sortField ? event.sortField : '');
        setSortOrder(event.sortOrder);
        if (event.sortOrder === -1) {
            setQuerySortOrder('-');
        } else {
            setQuerySortOrder('');
        }
    };
    const errorModal = () => {
        return (
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                Column
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title> {errorDetails.errorType}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <strong>Name:</strong> {errorDetails.firstName} <br />
                        <strong>Email:</strong> {errorDetails.email} <br />
                    </div>
                    <hr
                        style={{
                            height: '1px',
                            border: 'none',
                            backgroundColor: '#d2d2d2',
                        }}
                    />
                    <div className="row">
                        <div className="col-12 col1">
                            <textarea
                                className="textarea1"
                                value={errorDetails.errorMessage}
                                style={{
                                    color: 'red',
                                    backgroundColor: 'black',
                                    width: '100%',
                                    height: '200px',
                                }}
                                disabled
                            ></textarea>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    const PROGGRMMING_COLUMN_DISPLAY_NAMES = {
        evaluationmarks: "Evaluation Marks",
        manualmarks: "Manual Marks",
        rubricmarks:"Rubric Marks",
        totalmarks: "Total Marks"
    };    
    const VIRTUAL_COLUMN_DISPLAY_NAMES = {
        evaluationmarks: "Evaluation Marks",
        manualmarks: "Manual Marks",
        totalmarks: "Total Marks"
    };    


    const columns = [
        {
            selectionMode: 'multiple',
            headerStyle: { width: '3rem' },
            frozen: true,
        },
        {
            headerStyle: { width: '3rem' },
            header: 'S.No.',
            frozen: true,
            body: (data, options) => options.rowIndex + 1,
            style: { textAlign : "center" },
        },
        {
            field: 'email',
            header: 'Email',
            frozen: true,
            sortable: true,
            hidden: !visibleLabSubmisssionsColumns?.some(
                (column) => column.name === 'Email'
            ),
            style: { width: '250px' },
        },
        {
            field: 'first_name',
            header: 'Name',
            sortable: true,
            hidden: !visibleLabSubmisssionsColumns?.some(
                (column) => column.name === 'Name'
            ),
            style: { width: '100px' },
        },
        {
            field: 'roll_no',
            header: 'Roll No',
            sortable: true,
            hidden: !visibleLabSubmisssionsColumns?.some(
                (column) => column.name === 'Roll no'
            ),
            style: { width: '100px' },
        },
        {
            field: 'latestupload',
            header: 'Uploaded On',
            sortable: true,
            hidden: !visibleLabSubmisssionsColumns?.some(
                (column) => column.name === 'Uploaded on'
            ),
            style: { width: '150px' },
            // body: (data) => renderCell(data, { field: 'latestupload' }),
            body: timeTemplate,
        },
        {
            field: 'activitiesdone',
            header: `Lab Activities(${activities.length})`,
            sortable: true,
            hidden: !visibleLabSubmisssionsColumns?.some(
                (column) => column.name === 'Activities Submitted'
            ),
            style: { width: '150px', textAlign: 'right' },
        },

        //  testcases is an array of objects with testcase names and identifiers

        // ...activities.map((activity, i) => ({
        //     key: i + 'total',
        //     header: (
        //         <a
        //             href={`/courseware/course/${courseId}/content/labs/${labID}/${activity[1]}/${activity[2]}/submissions`}
        //         >
        //             {activity[1] + ':' + activity[0]}
        //         </a>
        //     ),
        //     body: (data) =>
        //         data?.activities[activity[0]]?.totalmarks != undefined
        //             ? data.activities[activity[0]].totalmarks
        //             : 'Not Attempted',
        //     hidden: !visibleLabSubmisssionsColumns?.some(
        //         (column) => column.name === 'Activities'
        //     ),
        //     style: { width: '100px', textAlign: 'right' },
        // })),
        // ...activities.map((activity, i) => ({
        //     key: i + 'manual',
        //     header: (
        //         <a
        //             href={`/courseware/course/${courseId}/content/labs/${labID}/${activity[1]}/${activity[2]}/submissions`}
        //         >
        //             {activity[1] + ':' + activity[0] + '-manual marks'}
        //         </a>
        //     ),
        //     body: (data) =>
        //         data?.activities[activity[0]]?.manualmarks != undefined
        //             ? data.activities[activity[0]].manualmarks
        //             : 'Not Attempted',
        //     hidden: !visibleLabSubmisssionsColumns?.some(
        //         (column) => column.name === 'Activities'
        //     ),
        //     style: { width: '100px', textAlign: 'right' },
        // })),

        ...activities.flatMap((activity, i) =>{
            let columns = [];
            if(activity[1]==="virtual"){
                columns=['evaluationmarks','manualmarks'];
            }
            else if(activity[1]==="programming"){
                columns=['evaluationmarks','manualmarks','rubricmarks'];
            }
            return columns.map((type) => ({
                key: `${i}${type}`,
                header: (
                    <a
                        href={`/courseware/course/${courseId}/content/labs/${labID}/${activity[1]}/${activity[2]}/submissions`}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            whiteSpace: 'normal',
                            alignItems:"center",
                            width:"230px",
                            paddingRight:"25px",
                        }}
                    >
                        <div>{activity[1]}</div>
                        <div>{activity[0]}</div>
                        <div>{activity[1] === 'virtual'
                            ? VIRTUAL_COLUMN_DISPLAY_NAMES[type] || type
                            : activity[1] === 'programming'
                            ? PROGGRMMING_COLUMN_DISPLAY_NAMES[type] || type
                            : type}
                        </div>
                    </a>
                ),
                body: (data) => {
                    const value = data?.activities?.[activity[0]]?.[type];

                    return value !== undefined && value !== null ? (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-${data.username}`}>{'Upload TimeStamp ' + getFormattedTimeStamp(data?.activities?.[activity[0]]?.['uploadtimestamp'])}</Tooltip>}
                        >
                            <span>{value}</span>
                        </OverlayTrigger>
                    ) : (
                        'Not Attempted'
                    );
                },
                hidden: !visibleLabSubmisssionsColumns?.some(
                    (column) => column.name === 'Activities'
                ),
                style: {  textAlign: 'center' ,maxWidth:"230px"},
                headerStyle:{maxWidth:"230px"}
            }))
        }
        ),
        

        // {
        //     field: 'totalmarks',
        //     header: 'Total Marks',
        //     sortable: true,
        //     style: { width: '120px', textAlign: 'center' },
        // },
    ];

    return (
        <div>
            {loaded ? (
                <div className="cont">
                    {/* <Navbar navbarClass="navbar-dark fixed-top" /> */}
                    <Breadcrumb>
                        <Breadcrumb.Item
                            href={`/courseware/course/${courseId}`}
                        >
                            {coursename}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item
                            href={`/courseware/course/${courseId}/content/labs`}
                        >
                            Labs
                        </Breadcrumb.Item>
                        <Breadcrumb.Item
                            href={`/courseware/course/${courseId}/content/labs/${labID}/`}
                        >
                            {labTitle}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Submissions</Breadcrumb.Item>
                    </Breadcrumb>

                    <hr
                        style={{
                            height: '1px',
                            border: 'none',
                            backgroundColor: 'grey',
                            marginTop: '-1rem',
                        }}
                    />
                    {showHeaderComponent()}
                    {errorModal()}

                    <hr
                        style={{
                            height: '1px',
                            border: 'none',
                            backgroundColor: 'grey',
                            marginBottom: '0rem',
                            marginTop: '1.5rem',
                        }}
                    />
                    <div style={{ paddingRight: '5px' }}>
                        <TableComponent
                            /*Mandatory props*/

                            //Data to be displayed
                            tableData={submissions}
                            //Definition of columns to be displayed
                            columns={columns}
                            scrollable={true}
                            //Height of the table
                            scrollHeight="600px"
                            /*Optional props
                            Required for Infinte scrolling
                            Server Side searching and Sorting*/

                            //Change table data
                            setTableData={setSubmissions}
                            //Table header
                            tableHeader={tableHeader}
                            //To display the loading template. Loading template will be rendered if lazyLoading is true
                            lazyLoading={lazyLoading}
                            //To set lazyloding
                            setLazyLoading={setLazyLoading}
                            //Template to diplay while data is loading
                            loadingTemplate={loadingTemplate}
                            //To check if new data is loaded
                            isNewData={isNewData}
                            //To set the value of isNewData
                            setIsNewData={setIsNewData}
                            //api of data
                            api={`${constants.base_url}/evalpro/labsubmissions/${labID}`}
                            //Location of data in response
                            location={'data.submissions.submissions.results'}
                            debouncedSearchQuery={debouncedSearchQuery}
                            querySortOrder={querySortOrder}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            handleSort={handleSort}
                            stripedRows={false}
                            showGridlines={false}
                            selectedRowData={selectedSubmissions}
                            setSelectedRowData={setSelectedSubmissions}
                            isSelectAllChecked={isSelectAllChecked}
                            setIsSelectAllChecked={setIsSelectAllChecked}
                            isServerSide={true}
                            isInfiniteScroll={true}
                            program_id={labID}
                            selectionMode={"checkbox"}
                            numberOfRows={100}
                        />
                    </div>
                </div>
            ) : (
                <div className="h-screen flex justify-content-center align-items-center">
                    <Spinner animation="border" />
                </div>
            )}

            <br />
            <br />
        </div>
    );
}

export default Submissions;
